import { create } from 'zustand';

const useGraphStore = create((set) => ({
  price: null,
  date: null,
  time: null,
  onPriceHover: (value) => set({ price: value }),
  onDateHover: (value) => set({ date: value }),
  onTimeHover: (value) => set({ time: value }),
}));

export default useGraphStore;
